var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinkBokunDatahub = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152.24 29.23",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-3{fill-rule:evenodd;}.cls-2,.cls-3{fill:#f065a2;}.cls-4{mask:url(#mask);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 80.24,
    y: 0,
    width: 28,
    height: 29,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29.21 -75.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "cls-1",
    d: "M121.54,75.72a6.08,6.08,0,0,0-4.21,1.66h0a7.46,7.46,0,0,0-2,5.41h0c0,.22,0,.45,0,.67h0a8.94,8.94,0,0,0-4,1.93h0a5.07,5.07,0,0,0-1.9,3.75h0a4.71,4.71,0,0,0,1.22,3h0a4.47,4.47,0,0,1,1.09,2.37h0a9,9,0,0,0,.72,2h0a14.3,14.3,0,0,0,12.58,8.16h.26a9.71,9.71,0,0,0,6-2.11h0a8.07,8.07,0,0,0,2.59-4.08h0a22.71,22.71,0,0,1,1.64-4.8h0A28.3,28.3,0,0,0,137.05,90h0a8.15,8.15,0,0,0,.4-2.34h0a3.38,3.38,0,0,0-1.19-2.78h0a5,5,0,0,0-3.13-.88h-.25a11.91,11.91,0,0,0-.76-1.46h0a6.27,6.27,0,0,0-5.54-3.29h0l-.44-.77h0a5.09,5.09,0,0,0-4.48-2.71h-.12Zm4,3c.09.17.18.34.28.5h0c-2.71.23-5.58,1.79-8.08,3.83h0c-.63.09-1.24.19-1.82.29h0c0-.19,0-.39,0-.56h0a6.84,6.84,0,0,1,1.84-5h0a5.48,5.48,0,0,1,3.76-1.46h0a4.44,4.44,0,0,1,4,2.36Zm-3.77,2.84a10.62,10.62,0,0,1,4.63-1.36h0a12.32,12.32,0,0,0,2.2,2.77h0a6,6,0,0,0,3.46,1.61h0a25.36,25.36,0,0,1,1.31,9h0c0,.81,0,1.68-.08,2.61h0v.24a21.58,21.58,0,0,1-2,2.71h0l-.34.36a14.38,14.38,0,0,0,1.29-6.1h0A15.45,15.45,0,0,0,130.88,87h0a6.67,6.67,0,0,0-3.69-3.39h0a13.65,13.65,0,0,0-5.14-.85h0c-1.31,0-1.28-.63-.24-1.16Zm7.24.89a11.68,11.68,0,0,1-1.84-2.24h0A5.34,5.34,0,0,1,131.32,83h0c.16.26.31.55.46.85h0a5.41,5.41,0,0,1-2.73-1.39Zm-6,19a36,36,0,0,1-4.14-4.08h0c-.35-.39-.72-.75-1.09-1.13h0c0-.5,0-1,0-1.61h0a29,29,0,0,0-1.08-7.81h0c-.06-.21-.13-.42-.2-.64h0c-.31-.94.26-1.52,2.22-1.76h0a28.3,28.3,0,0,1,3.32-.19h0a12.46,12.46,0,0,1,4.6.73h0a5.22,5.22,0,0,1,2.92,2.66h0a13.9,13.9,0,0,1,1.21,5.82h0c0,3.41-1.16,6.68-3.4,8.19h0a3.62,3.62,0,0,1-2,.72h0a4,4,0,0,1-2.3-.9Zm11.27-10a24.1,24.1,0,0,0-1.2-6.79h0a4.28,4.28,0,0,1,2.72.75h0a2.67,2.67,0,0,1,1,2.26h0a7.06,7.06,0,0,1-.37,2.13h0c-.19.59-.39,1.18-.61,1.75h0c-.31.8-.7,1.42-1,1.42h0c-.25,0-.45-.42-.5-1.52ZM110.9,89.14a3.58,3.58,0,0,1,1.39-2.62h0a7.5,7.5,0,0,1,3.22-1.59h0a.8.8,0,0,0,0,.15h0a19,19,0,0,0-2.06,2.41h0a10.58,10.58,0,0,0-1.7,3.72h0a3.16,3.16,0,0,1-.88-2.07Zm2.41,3.36a8.24,8.24,0,0,1-.69-.5h0a9.12,9.12,0,0,1,1.65-3.94h0a17.48,17.48,0,0,1,1.56-1.88h0a.83.83,0,0,1,.06.21h0a30.16,30.16,0,0,1,1.28,9.21h0a25,25,0,0,0-3.86-3.1Zm0,3.62a7.82,7.82,0,0,1-.72-2.32h0a26.33,26.33,0,0,1,4.67,4h0a8.77,8.77,0,0,0,.69,2.94h0a4.74,4.74,0,0,0,1,1.38h0a13.55,13.55,0,0,1-5.64-6Zm14.89,6.71a7.38,7.38,0,0,0,1.23-1.07h0a16.43,16.43,0,0,0,2.32-2.17h0a19.7,19.7,0,0,0,1.35-1.67h0a7.12,7.12,0,0,1-2.38,3.93h0a8.24,8.24,0,0,1-4,1.75h0a5.67,5.67,0,0,0,1.51-.77Zm-7.15-.13a4.64,4.64,0,0,1-2.52-2.27h0a6.55,6.55,0,0,1-.53-1.9h0c.46.51.9,1,1.36,1.47h0a21.67,21.67,0,0,0,2.85,2.65h0a8.51,8.51,0,0,0,.9.57h0a7,7,0,0,1-2.05-.52Z"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.13,100.74a.9.9,0,0,0-.89-.89H32.48v1.81H35a1.14,1.14,0,0,0,.84-.27A.91.91,0,0,0,36.13,100.74Zm-3.65-5.36V97.1h1.68a1,1,0,0,0,.74-.26.88.88,0,0,0,.26-.61.85.85,0,0,0-.86-.85Zm7.27,5.36a3.63,3.63,0,0,1-1.08,2.62,4,4,0,0,1-3.12,1.11H29.21V92.67h5.4a3.67,3.67,0,0,1,3,1.07,3.35,3.35,0,0,1,.89,2.5,2.16,2.16,0,0,1-.53,1.6,1.19,1.19,0,0,1,.7.36A3.41,3.41,0,0,1,39.75,100.74Z",
    transform: "translate(-29.21 -75.72)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.61,92.67v7.18a4.86,4.86,0,0,1-1.5,3.6,5.14,5.14,0,0,1-7.24,0,4.86,4.86,0,0,1-1.5-3.6V92.67h3.71v7.18a1.41,1.41,0,0,0,2.82,0V92.67Z",
    transform: "translate(-29.21 -75.72)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85,92.66V98l-3.81-5.37H77.53v11.8h3.68V99L85,104.48h3.69V92.66Z",
    transform: "translate(-29.21 -75.72)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.48,92.66H60.82l-3.21,4.08V92.66h-3.7v11.81h3.7v-4.09l3.21,4.09h4.66L61,98.56Z",
    transform: "translate(-29.21 -75.72)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.53,96.72a2.68,2.68,0,0,0-3.78,0A2.54,2.54,0,0,0,44,98.6a2.57,2.57,0,0,0,.78,1.88,2.7,2.7,0,0,0,3.78,0,2.48,2.48,0,0,0,.81-1.88A2.45,2.45,0,0,0,48.53,96.72Zm2.63,6.35a6.4,6.4,0,0,1-9,0,6.35,6.35,0,0,1,9-8.95,6.27,6.27,0,0,1,0,8.95Z",
    transform: "translate(-29.21 -75.72)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.87,78.3h0L65.25,85,66,83.76l-1-1-2.47,2.06-1.24-.39-7.17,6.5H88.59l-1.54-1.12-6-5.2-4.27,2.5,2.77-1.93ZM65.62,86l6.2-6.28,2.66,3.5a9.21,9.21,0,0,0-1.54-.69s0,0,0,0-2.37,2.89-2.37,2.89l-.12-1.65-.46.92-.06-.83Zm-1.05-2-.78,1.68-.26-.25L61.11,88.1s0-.35,0-.48,0,0-.05,0a3.57,3.57,0,0,0-.73.27l.75-1.55-1.55.33,2-1.52.73.74ZM77,87.88l4.14-2.4L83,87l-1.11,0-.83.87,0-1.06-4.05,1Z",
    transform: "translate(-29.21 -75.72)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.32,88.26l-2.76,2.67H45.11l2.45-2.67Z",
    transform: "translate(-29.21 -75.72)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows_RightPink",
    "data-name": "Arrows/RightPink"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "cls-3",
    points: "72.21 11.09 76.88 15.7 77.25 16.09 76.88 16.48 72.21 21.09 71.42 20.31 75.14 16.64 64.13 16.64 64.13 15.55 75.14 15.55 71.42 11.87 72.21 11.09"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "cls-3",
    points: "80.24 29 108.25 29 108.25 0 80.24 0 80.24 29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "cls-3",
    d: "M145.41,95.67c1.22,0,2.22-.52,2.22-1.85S146.76,92,145.57,92h-.89v3.7Zm-1.71-4.58h2.16a2.61,2.61,0,0,1,2.79,2.73,2.76,2.76,0,0,1-2.9,2.73H143.7Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "cls-3",
    d: "M151.61,94.88h-.2c-.51,0-1.39,0-1.39.58,0,.33.35.48.65.48.63,0,.94-.33.94-.85Zm0,1.16h0a1.33,1.33,0,0,1-1.2.6,1.2,1.2,0,0,1-1.35-1.11c0-1.2,1.41-1.29,2.32-1.29h.23v-.1c0-.45-.35-.69-.85-.69a1.45,1.45,0,0,0-1,.39l-.49-.49a2.17,2.17,0,0,1,1.58-.59,1.41,1.41,0,0,1,1.59,1.66v2.13h-.84Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "cls-3",
    d: "M152.89,93.64v-.77h.77V91.78h.93v1.09h1v.77h-1v1.62c0,.38.11.6.52.6a.92.92,0,0,0,.51-.12v.78a2.09,2.09,0,0,1-.74.12c-1,0-1.22-.44-1.22-1.31V93.64Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "cls-3",
    d: "M158.45,94.88h-.19c-.51,0-1.39,0-1.39.58,0,.33.35.48.65.48.63,0,.93-.33.93-.85Zm.06,1.16h0a1.34,1.34,0,0,1-1.2.6,1.2,1.2,0,0,1-1.35-1.11c0-1.2,1.41-1.29,2.32-1.29h.23v-.1c0-.45-.35-.69-.85-.69a1.45,1.45,0,0,0-1,.39l-.49-.49a2.17,2.17,0,0,1,1.58-.59,1.41,1.41,0,0,1,1.59,1.66v2.13h-.84Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    className: "cls-3",
    points: "131.04 15.37 132.02 15.37 132.02 17.54 134.58 17.54 134.58 15.37 135.56 15.37 135.56 20.83 134.58 20.83 134.58 18.43 132.02 18.43 132.02 20.83 131.04 20.83 131.04 15.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "cls-3",
    d: "M169.16,96.55h-.88V96a1.17,1.17,0,0,1-1.14.69,1.29,1.29,0,0,1-1.36-1.46V92.87h.93v1.87c0,.41,0,1.09.68,1.09a.83.83,0,0,0,.86-.8.61.61,0,0,0,0-.14v-2h.92Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "cls-3",
    d: "M172,93.59a1.11,1.11,0,1,0,1.09,1.13v0a1.07,1.07,0,0,0-1-1.11Zm-2-2.87H171v2.6h0a1.56,1.56,0,0,1,1.26-.56,1.93,1.93,0,0,1,0,3.85,1.43,1.43,0,0,1-1.28-.65v.56h-.88Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    className: "cls-3",
    points: "114.24 23.44 114.79 23.44 116.56 28.23 118.34 23.44 118.89 23.44 116.8 28.9 116.29 28.9 114.24 23.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    className: "cls-3",
    d: "M148.63,104.62h.66v-3.57h-.66Zm.33-5.33c.28,0,.5.16.5.35s-.22.35-.5.35-.5-.16-.5-.35.22-.35.5-.35Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    className: "cls-3",
    d: "M150.13,103.71a1.16,1.16,0,0,0,1,.59.77.77,0,0,0,.83-.66c0-1-2.13-.29-2.13-1.66a1.11,1.11,0,0,1,1.23-1,1.31,1.31,0,0,1,1.26.67l-.42.25a.85.85,0,0,0-.84-.5c-.34,0-.78.2-.78.57,0,1,2.12.21,2.12,1.66a1.15,1.15,0,0,1-1.29,1.1,1.58,1.58,0,0,1-1.44-.72Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    className: "cls-3",
    d: "M153.34,104.62H154v-3.57h-.66Zm.3-5.33c.27,0,.5.16.5.35s-.23.35-.5.35-.5-.16-.5-.35.22-.35.5-.35Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-29",
    className: "cls-3",
    d: "M156.55,101.47h-1v2.31a.46.46,0,0,0,.42.5.11.11,0,0,0,.08,0,1.24,1.24,0,0,0,.53-.12l0,.42a2.13,2.13,0,0,1-.61.12.83.83,0,0,1-.92-.73.6.6,0,0,1,0-.19v-2.31h-.78v-.42h.78v-1h.46v1h1Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    className: "cls-3",
    points: "129.56 23.44 132.84 23.44 132.84 23.9 130.07 23.9 130.07 25.83 132.65 25.83 132.65 26.29 130.07 26.29 130.07 28.89 129.56 28.89 129.56 23.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-31",
    className: "cls-3",
    d: "M162.83,104.62h.67v-3.57h-.67Zm.34-5.33c.27,0,.5.16.5.35s-.23.35-.5.35-.5-.16-.5-.35h0c0-.19.22-.35.5-.35Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-32",
    className: "cls-3",
    d: "M164.32,102.05c0-.26,0-.81,0-1h.46a3.24,3.24,0,0,0,0,.63h0A1.34,1.34,0,0,1,166,101c1.11,0,1.36.77,1.36,1.54v2.12h-.46v-2.12c0-.58-.17-1.16-.9-1.16s-1.24.48-1.24,1.46v1.79h-.47Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    className: "cls-3",
    points: "139.26 28.9 139.72 28.9 139.72 23.07 139.26 23.07 139.26 28.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-34",
    className: "cls-3",
    d: "M171.86,102.83c-.77,0-1.55.19-1.55.8a.75.75,0,0,0,.8.67h0a1.11,1.11,0,0,0,1.24-1,1.13,1.13,0,0,0,0-.26v-.24Zm.93.29a10.76,10.76,0,0,0,.07,1.5h-.43a3.79,3.79,0,0,1-.05-.58,1.3,1.3,0,0,1-1.28.67c-.62,0-1.27-.3-1.27-1.06,0-1.09,1.28-1.19,2-1.19h.54v-.22c0-.62-.44-.86-1-.86a1.6,1.6,0,0,0-1.09.38l-.27-.32a2.12,2.12,0,0,1,1.38-.47c.86,0,1.42.38,1.42,1.28Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-35",
    className: "cls-3",
    d: "M173.81,102.05c0-.26,0-.81,0-1h.46a3.24,3.24,0,0,0,0,.63h0a1.32,1.32,0,0,1,1.21-.71c1.11,0,1.36.77,1.36,1.54v2.12h-.46v-2.12c0-.58-.17-1.16-.9-1.16s-1.24.48-1.24,1.46v1.79h-.45Z",
    transform: "translate(-29.21 -75.72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-36",
    className: "cls-3",
    d: "M179.54,101.38a1.47,1.47,0,1,0,.15,0ZM181,104h0a1.63,1.63,0,0,1-1.43.72,1.88,1.88,0,0,1,0-3.75,1.66,1.66,0,0,1,1.43.72v-2.9h.46v5.84H181Z",
    transform: "translate(-29.21 -75.72)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinkBokunDatahub);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pink-bokun-datahub.7034798823e70436f8f4ea24919e6141.svg";